var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProspectRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10628 6684)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(10628 -6684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-441.154,1313.156a.531.531,0,0,0-.6-.106l-15.939,7.438a.531.531,0,0,0-.307.484.531.531,0,0,0,.312.481l5.663,2.574,2.574,5.663a.531.531,0,0,0,.481.312h0a.531.531,0,0,0,.481-.307l7.438-15.939A.531.531,0,0,0-441.154,1313.156Zm-2.884,2.132-7.7,7.7-4.459-2.027Zm-4.924,12.913-2.027-4.459,7.7-7.7Z",
    transform: "translate(11093.499 -7989.501)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectRequest);
export default __webpack_public_path__ + "static/media/prospect-request.aa4c98132529b24410cc5a7e61505fa9.svg";
export { ForwardRef as ReactComponent };